module.exports = __webpack_public_path__ + "235818b9a5bf7810fc4cc1b20c81338a.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/de/google_store.png
// module id = 868
// module chunks = 0